import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

export async function fetchUsers() {
  const response = await axios.get(`${API_BASE_URL}/users`);
  if (!response.data.success) throw new Error(response.data.message || 'Failed to fetch users');
  return response.data.users;
}

export async function createUser({ loginID, password, firstName, lastName, email, positionId }) {
  const response = await axios.post(`${API_BASE_URL}/users`, {
    loginID,
    password,
    firstName,
    lastName,
    email,
    positionId
  });
  if (!response.data.success) throw new Error(response.data.message || 'Failed to create user');
  return response.data;
}

export async function updateUser(id, { firstName, lastName, email, positionId, status, password }) {
  const body = { firstName, lastName, email, positionId, status };
  if (password && password.trim()) body.password = password.trim();
  const response = await axios.put(`${API_BASE_URL}/users/${id}`, body);
  if (!response.data.success) throw new Error(response.data.message || 'Failed to update user');
  return response.data;
}

export async function deleteUser(id) {
  const response = await axios.delete(`${API_BASE_URL}/users/${id}`);
  if (!response.data.success) throw new Error(response.data.message || 'Failed to delete user');
  return response.data;
}
